<template>
  <div class="dropdown">
    <MdlButton
      v-if="isMobile"
      data-toggle="dropdown"
      small
      icon="more_vert"
      :data-qa-id="pendo('openShopSwitcherForMobile')"
    />

    <MdlButton
      v-else
      data-toggle="dropdown"
      class="flex justify-between w-60 bg-white border-1 border-solid border-gray-200 rounded-md normal-case"
      :data-qa-id="pendo('openShopSwitcherForDesktop')"
    >
      <div class="flex gap-2">
        <span class="max-w-32 truncate normal-case">{{ country(selectedShop.country).name }}</span>
        <span name="language" small>{{ '(' + selectedShop.currency + ')' }}</span>
      </div>
      <b class="caret" />
    </MdlButton>

    <BMenu bottom>
      <BMenuItem v-for="shop in shops" :key="shop.id" @click="emit('change', shop)" class="w-60">
        <Icon
          v-if="isMobile"
          name="check"
          small
          class="px-2"
          :class="{
            'visible mdl-color-text--primary': shop.id === selectedShop?.id,
            invisible: shop.id !== selectedShop?.id,
          }"
          :data-qa-id="pendo(`switchToShop${shop.id}`)"
        />
        <span>{{ country(shop.country).i18n }} {{ '(' + shop.currency + ')' }}</span>
      </BMenuItem>
    </BMenu>
  </div>
</template>
<script setup lang="ts">
import { computed } from 'vue'
import { pendoLabel as pendo } from '@/munio/utils'

import MdlButton from '@component/mdl/Button.vue'
import BMenu from '@component/Menu.vue'
import BMenuItem from '@component/MenuItem.vue'
import Icon from '@component/Icon.vue'
import { ShopResourceDto } from '@/munio/api/data'

import { find } from 'lodash'

const props = withDefaults(
  defineProps<{
    shops: ShopResourceDto[]
    region?: string | null
    isMobile?: boolean
  }>(),
  {
    isMobile: false,
  },
)

const emit = defineEmits<{
  (e: 'change', shop: ShopResourceDto): void
}>()

const country = window.Munio.country

const selectedShop = computed(() => {
  if (props.region) {
    return find(props.shops, ['country', props.region]) || props.shops[0]
  }

  return props.shops[0]
})
</script>
